import { render, staticRenderFns } from "./BranchComponent.vue?vue&type=template&id=b83f69c2&"
import script from "./BranchComponent.vue?vue&type=script&lang=js&"
export * from "./BranchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports